// import styled from "styled-components";
import Image from "./Image"




/*
const StyledLoader = styled.span`
  width: 48px;
  height: 48px;
  border: 5px solid var(--color-border-primary);
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
`;
*/
const Loader = () => {
  return <Image src={`/animated.gif`} alt="Animated Logo" width="10%" />
};

export { Loader };
